import React, {FC, useEffect, useState} from 'react';
import {classNames} from 'classnames-generics';
import {useTranslation} from 'react-i18next';
import styles from './styles.module.scss';
import "./../../locales/langs";
import {useSelector} from 'react-redux';
import {MediakitSection, selectMediakitUser} from './../../features/stores/mediakitUser.slice';
import useRequest from './../../API/request';
import {store} from './../../app/store';
import {setDataChange, setShouldSave} from './../../features/stores/changeData.slice';
import {refreshMe} from './../../API/login';
import {toast} from 'react-toastify';
import RouteLeavingGuard from './../../components/UnsavedChanges/RouteLeavingGuard';
import RateContainer from './../../components/RatesContainer';
import {TailSpin} from 'react-loader-spinner';
import PreviewSite from './../../components/PreviewSite';
import {getConfig} from '../../features/stores/config.slice';
import {haveSegmentPermission} from '../../features/util';

const selectChangeData = (state: any) => state.changeData.changeData;
const selectShouldSave = (state: any) => state.changeData.shouldSaveEverything;

const Rates = () => {
    const {t} = useTranslation();
    const dataChange = useSelector(selectChangeData);
    const shouldSave = useSelector(selectShouldSave);
    const mediakitUser = useSelector(selectMediakitUser) as any;
    const config = useSelector(getConfig).data || [];
    const monetizeEnabled = haveSegmentPermission(config, 'monetize');
    const updateRateRequest = useRequest({method: 'POST', url: '/rates'});

    const saveRates = async () => {
        const mediakitSocialData = mediakitUser.mediakitSection.filter((e: any) => e.type === 'rates').map((section: MediakitSection) => section.mediakitSectionLinks).reduce((acc: any, curr: any) => {
            acc = [...acc, ...curr];
            return acc;
            });
        const socialPayload: any = [];
        mediakitSocialData.map((e: any) => {
            const data = JSON.parse(JSON.stringify(e));
            if (!/[^a-zA-Z0-9]/.test(data?.id)) {
                delete data.id;
            }
            socialPayload.push(data);
        });
        await updateRateRequest.doRequest({items: socialPayload});
        store.dispatch(setShouldSave(false));
        store.dispatch(setDataChange(false));
        toast(<span>{t('changes_saved')}</span>);
        refreshMe();
    };

    useEffect(() => {
          if (shouldSave && dataChange) {
            saveRates();
          }
    }, [shouldSave]);

    useEffect(() => {
        if (updateRateRequest.hasError) {
          toast.warning(<span>{t('something_went_wrong')}</span>);
        }
      }, [updateRateRequest.hasError]);

    useEffect(() => {
        if (!monetizeEnabled && config.length) {
            window.location.href = '/mediakit/profile/my-profile';
        }
    }, [monetizeEnabled]);

    return (
        <div className={classNames(styles.profile_container)}>
            <RouteLeavingGuard when={dataChange} navigate={() => '/mediakit/profile/rates'}
                shouldBlockNavigation={() => true} saveFunction={async ()=>{
                    await saveRates();
                    return true;
            }}/>
            {(shouldSave || updateRateRequest.isFetching) ? <div className={styles.loadingOnSave}><TailSpin color="#EB3B5A" height={80} width={80} /></div> : ''}
            <div className={styles.profile_left}>
                <div className={styles.left_container}>
                    <div className={styles.profile_body}>
                        <RateContainer />
                    </div>
                </div>
            </div>
            <div className={styles.profile_right}>
                {/* <CopyLinkCard /> */}
                <PreviewSite />
            </div>
        </div>
    );
};

export default Rates;
